import React from 'react';

const CustomCheckbox = (props) => {

    if(props.disabled) {
        return (
            <div>
                <input
                    id={props.name}
                    type="checkbox"
                    className="custom-checkbox--disabled"
                    checked={props.checked}
                    name={props.name}
                />
                <label htmlFor={props.name}></label>
                <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">{props.label}</span>
            </div>
        )
    }

    return(
        <div>
            <input
                id={props.name}
                type="checkbox"
                className="appFormRefSettings-check_box"
                checked={props.checked}
                name={props.name}
                onChange={props._onChange}/>
            <label htmlFor={props.name}></label>
            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">{props.label}</span>
        </div>
    )
};

export default CustomCheckbox;